import { render, staticRenderFns } from "./UserTrendAppViewTable.vue?vue&type=template&id=b703da2a&scoped=true"
import script from "./UserTrendAppViewTable.vue?vue&type=script&lang=ts"
export * from "./UserTrendAppViewTable.vue?vue&type=script&lang=ts"
import style0 from "./UserTrendAppViewTable.vue?vue&type=style&index=0&id=b703da2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b703da2a",
  null
  
)

export default component.exports